
import router from "@/app/ui/router";
import { computed, defineComponent, onMounted, ref, watch } from "vue";
import ManagementLoginApproval from "./components/tabs-approval.vue";
import ManagementLoginDevice from "./components/tabs-device.vue";
import ManagementLoginHistory from "./components/tabs-history.vue";
import { FcsPermissionManagementLoginApproval } from "@/feature-flags/flags-management-login-approval";
import { MainAppController } from "../../controllers/MainAppController";

export default defineComponent({
  name: "ManagementLogin",
  components: {
    ManagementLoginApproval,
    ManagementLoginDevice,
    ManagementLoginHistory
  },
  setup() {
    const tabs = computed(() =>
      [
        {
          value: "ManagementLoginApproval",
          title: "Permintaan login",
          permission: FcsPermissionManagementLoginApproval.permission_tab_approval_enable.isEnabled()
        },
        {
          value: "ManagementLoginDevice",
          title: "Informasi perangkat tim Anda",
          permission: FcsPermissionManagementLoginApproval.permission_tab_device_enable.isEnabled()
        },
        {
          value: "ManagementLoginHistory",
          title: "Riwayat",
          permission: FcsPermissionManagementLoginApproval.permission_tab_history_enable.isEnabled()
        }
      ].filter((tab) => tab.permission)
    );

    const activeMenu = ref("");

    const onChangeTabs = (name: string) => {
      activeMenu.value = name;
      router.push({ name });
    };

    onMounted(() => {
      activeMenu.value = router.currentRoute.value.name as string;
    });

    // 🔥 Watch router changes
    watch(
      () => router.currentRoute.value.name,
      (newName) => {
        if (!newName) return;

        // only update if exists in tabs
        const isExist = tabs.value.some((t) => t.value === newName);

        if (isExist) {
          activeMenu.value = newName as string;
        }
      }
    );

    return {
      activeMenu,
      tabs,
      onChangeTabs,
      isSidebarAndBreadcrumbV2: computed(
        () => MainAppController.isSidebarAndBreadcrumbV2
      )
    };
  }
});
